var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleGradient = function SvgPeopleGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#peopleGradient_svg__a)",
    fillRule: "evenodd",
    d: "M8.25 5.25a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3 8.25a5.25 5.25 0 1 1 8.847 3.824 8.26 8.26 0 0 1 4.55 6.126 1.125 1.125 0 1 1-2.222.352 6.002 6.002 0 0 0-11.85 0 1.126 1.126 0 0 1-2.223-.354 8.26 8.26 0 0 1 4.55-6.123A5.24 5.24 0 0 1 3 8.25M16.5 6a1.125 1.125 0 1 0 0 2.25 2.25 2.25 0 0 1 .999 4.266 1.12 1.12 0 0 0-.624 1.008v.528a1.126 1.126 0 0 0 .86 1.095 5.26 5.26 0 0 1 3.784 3.558 1.127 1.127 0 0 0 1.407.75 1.124 1.124 0 0 0 .744-1.41 7.52 7.52 0 0 0-3.84-4.518A4.5 4.5 0 0 0 16.5 6",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "peopleGradient_svg__a",
    x1: 11.904,
    x2: 11.904,
    y1: 3,
    y2: 19.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00DE"
  })))));
};
export default SvgPeopleGradient;